import styled from 'styled-components';

export const StyledEventRounds = styled.div`
  .list {
    padding: 0;
    margin-top: 0;
  }
`;
